import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useChangeEmailMutation } from "../../hooks/mutations/useChangeEmailMutation"

import { ChangeEmailForm } from "./ChangeEmailForm.form"

export const ChangeEmailFormPost = (props) => {
    const {
        onSuccess,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const { mutateAsync: changeEmail } = useChangeEmailMutation({
        successSnackbarMessage: t(I18N_NAMESPACE, "forms.changeEmailForm.snackbar.success"),
        errorSnackbarMessage: t(I18N_NAMESPACE, "forms.changeEmailForm.snackbar.error"),
        onSuccess: onSuccess,
    })

    return <ChangeEmailForm autoFocus onSubmit={changeEmail} />
}

ChangeEmailFormPost.propTypes = {
    onSuccess: PropTypes.func,
}